@if (fileRequest) {
  <div class="public-report adjustPagePosition">
    <h1 class="text-2xl font-medium">{{ reportTitle }}</h1>
    @if (downloadError) {
      <p class="mt-4">This report could not be downloaded.</p>
    } @else if (downloading || qb.loading) {
      <p class="mt-4"><em>Preparing your download...</em></p>
    } @else {
      <p class="mt-4">Your file should download automatically.</p>
    }
    <p class="mt-4">
      <a class="link" [routerLink]="['/r', agencyPrefix, reportName]">View this report online</a>
    </p>
  </div>
} @else {
  <div class="public-report adjustPagePosition">
    <div class="mb-6">
      <h1 class="text-3xl font-medium">{{ agencyName }}</h1>
      <h2 class="text-2xl mt-2">{{ reportTitle }}</h2>
      <p class="text-sm mt-2 text-gray-600">Generated: {{ loadedAt | date: 'MM/dd/yyyy hh:mm a' }}</p>
      <p class="text-sm mt-2">
        Download:
        <a class="link" href="/r/{{ agencyPrefix }}/{{ reportName }}/pdf" target="_blank" rel="noopener">PDF</a>
        |
        <a class="link" href="/r/{{ agencyPrefix }}/{{ reportName }}/excel" target="_blank" rel="noopener">Excel</a>
      </p>
    </div>

    @if (reportDataSources.length) {
      <div id="table-area" class="my-3">
        @for (reportDataSource of reportDataSources; track i; let i = $index) {
          <table mat-table matSort matSortDisableClear="true" [dataSource]="reportDataSource" multiTemplateDataRows class="w-full">
            <ng-container matColumnDef="company">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Company Name</th>
              <td mat-cell *matCellDef="let app"><span class="mobile-label">Company Name:</span>{{ app.company }}</td>
            </ng-container>
            <ng-container matColumnDef="address">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Address</th>
              <td mat-cell *matCellDef="let app">
                <span class="mobile-label">Address:</span>{{ app.address1 }}<br />
                {{ app.city }}, {{ app.state }} {{ app.zipCode }}
              </td>
            </ng-container>
            <ng-container matColumnDef="contractor">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Contact Name</th>
              <td mat-cell *matCellDef="let app"><span class="mobile-label">Contact Name:</span>{{ app.contractor }}</td>
            </ng-container>
            <ng-container matColumnDef="phoneNumber">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Phone #</th>
              <td mat-cell *matCellDef="let app"><span class="mobile-label">Phone #: </span>{{ app.phoneNumber | mask: '(000) 000-0000' }}</td>
            </ng-container>
            <ng-container matColumnDef="emailAddress">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Email</th>
              <td mat-cell *matCellDef="let app"><span class="mobile-label">Email: </span>{{ app.emailAddress }}</td>
            </ng-container>
            <ng-container matColumnDef="licenseString">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">License Classifications</th>
              <td mat-cell *matCellDef="let app"><span class="mobile-label">License Classifications:</span>{{ app.licenseString }}</td>
            </ng-container>
            <ng-container matColumnDef="rateFinalization">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Approved For</th>
              <td mat-cell *matCellDef="let app"><span class="mobile-label">Approved For:</span> {{ app.rateFinalization | currency }}</td>
            </ng-container>
            <ng-container matColumnDef="expirationDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header class="table-header">Expires</th>
              <td mat-cell *matCellDef="let app"><span class="mobile-label">Expires:</span> {{ app.expirationDate | date: 'M/dd/yyyy' }}</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
            <tr mat-row *matRowDef="let row; columns: columnsToDisplay" class="hover:bg-gray-100"></tr>
            <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="columnsToDisplay.length">
                <em> There are currently no applications to display. </em>
              </td>
            </tr>
          </table>
          <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions" aria-label="Select page"> </mat-paginator>
        }
      </div>
    } @else if (loading || qb.loading) {
      <div class="my-3">
        <p>
          <em>Loading report...</em>
        </p>
      </div>
    } @else {
      <div class="my-3">
        <p>
          <em>There are currently no applications to display.</em>
        </p>
      </div>
    }
  </div>
}
